import { useState } from 'react';
import type { OemContext } from '../../lib/auth';
import type { OemWorkspace } from '../../lib/oem-client';
import { ownerSummary } from './owner-summary-model';
export function OwnerSummary({
  context,
  workspace,
  now,
  link,
}: {
  context: OemContext;
  workspace: OemWorkspace;
  now: number;
  link: (key: string) => string;
}) {
  const [sku, setSku] = useState('');
  const model = ownerSummary(context, workspace, sku, now);
  if (!model) return null;
  const chart = (name: string, rows: { key: string; label: string; count: number }[]) => (
    <section className="owner-chart" aria-label={name}>
      <h3>{name}</h3>
      {rows.map((row) => (
        <div key={row.key} className="chart-row">
          <span>{row.label}</span>
          <span className="chart-track">
            <span
              style={{ width: `${(100 * row.count) / Math.max(1, ...rows.map((r) => r.count))}%` }}
            />
          </span>
          <strong>{row.count}</strong>
        </div>
      ))}
    </section>
  );
  return (
    <section className="card owner-summary" aria-label="สรุปโครงการสำหรับเจ้าของกิจการ">
      <h2>ภาพรวมโครงการนี้</h2>
      <p>{workspace.project.label} · นับฉบับล่าสุดของแต่ละรายการที่คุณมีสิทธิ์ดู</p>
      <label>
        ขอบเขต SKU ในภาพรวม
        <select value={sku} onChange={(e) => setSku(e.target.value)}>
          <option value="">ทั้งหมดที่มองเห็นในโครงการนี้</option>
          <option value="project">รายการระดับโครงการ</option>
          {workspace.skus.map((s) => (
            <option value={s.id} key={s.id}>
              {s.label}
            </option>
          ))}
        </select>
      </label>
      <p className="owner-total">
        <strong>{model.records.length}</strong> รายการล่าสุด · {model.tasks.length} งานที่มองเห็น
      </p>
      {model.records.length ? (
        <div className="owner-charts">
          {chart('สถานะที่บันทึกไว้', model.statuses)}
          {chart('กำหนดส่งงาน · เวลากรุงเทพฯ', model.deadlines)}
        </div>
      ) : (
        <p>ยังไม่มีรายการที่มองเห็นในขอบเขตนี้</p>
      )}
      <a href={link('work-list')}>เปิดรายการงานเพื่อติดตาม</a>
      <p className="scope">
        ไม่รวมข้อมูลที่ไม่ได้แชร์หรืออยู่นอกสิทธิ์ · สถานะที่บันทึกไม่ใช่ผลอนุมัติ ความพร้อมผลิต
        หรือรายได้
      </p>
    </section>
  );
}
